import type { ApiSearchQuery } from '@/lib/api/api-type-helper';

import type { SoftwarePeopleTableRow } from './-types';

type QUERY = ApiSearchQuery<'/v2/app-people/count', 'get'>;

type ORDER_BY = Exclude<QUERY, undefined>['orderBy'];
export type ORDER_BY_FILTER = Extract<
  ORDER_BY,
  'PERSON_NAME' | 'PLACE' | 'JOB_TYPE' | 'JOINED_ON' | 'LEFT_ON'
>;

export const SortColumns = [
  'PERSON_NAME',
  'PLACE',
  'JOB_TYPE',
  'JOINED_ON',
  'LEFT_ON',
] as const satisfies ORDER_BY_FILTER[];

export type SORTABLE_COLUMNS = Extract<
  keyof SoftwarePeopleTableRow,
  'person' | 'place' | 'jobTypes' | 'joinedOn' | 'leftOn'
>;

export const ColumnsToSortColumns = {
  person: 'PERSON_NAME',
  place: 'PLACE',
  jobTypes: 'JOB_TYPE',
  joinedOn: 'JOINED_ON',
  leftOn: 'LEFT_ON',
} as const satisfies Record<SORTABLE_COLUMNS, ORDER_BY_FILTER>;

export const SortColumnsToColumns = {
  PERSON_NAME: 'person',
  PLACE: 'place',
  JOB_TYPE: 'jobTypes',
  JOINED_ON: 'joinedOn',
  LEFT_ON: 'leftOn',
} as const satisfies Record<ORDER_BY_FILTER, SORTABLE_COLUMNS>;

export { Columns, type Columns as ColumnsType } from './-enums/columns';
